/* eslint-disable no-debugger, no-console, prettier/prettier */
import { service } from "@/api/service ";

const state = {
    isLoading: true,
    gateways: [],
    gatewayCode : ''
};
const getters = {
    loading: (state) => state.isLoading,
    gateways: (state) => state.gateways,
    gatewayCodeGetter : (state) => state.gatewayCode
};
const actions = {
    setPageLoading({ commit }, payload) {
        commit("SET_LOADING", payload);
    },
    fetchGateways({ commit }) {
        commit('fetchGateways')
    }
};
const mutations = {
    SET_LOADING(state, payload) {
        state.isLoading = payload;
    },
    SET_GATEWAY(state , payload){
        state.gatewayCode = payload
    },
    async fetchGateways(state,) {
        const result = await service.getFun('user/payment_gateways');
        if (result && result.success === true)
            state.gateways = result.data
        state.isLoading = false
    }
};
export default {
    state,
    getters,
    actions,
    mutations,
};
